import { Autocomplete } from '@base-ui/react/autocomplete';
import { Icon } from '@petsmart-ui/sparky';
import type { ComponentProps, PointerEventHandler, RefObject, SubmitEventHandler } from 'react';

type SearchInputKeyDownHandler = NonNullable<ComponentProps<typeof Autocomplete.Input>['onKeyDown']>;

type SearchControlsProps = {
    controlsRef: RefObject<HTMLDivElement | null>;
    formRef: RefObject<HTMLFormElement | null>;
    inputRef: RefObject<HTMLInputElement | null>;
    onCancel?: () => void;
    onInputFocus: () => void;
    onInputKeyDown: SearchInputKeyDownHandler;
    onSubmit: SubmitEventHandler<HTMLFormElement>;
    query: string;
};

export function SearchControls({
    controlsRef,
    formRef,
    inputRef,
    onCancel,
    onInputFocus,
    onInputKeyDown,
    onSubmit,
    query,
}: SearchControlsProps) {
    const handleCancelPointerDown: PointerEventHandler<HTMLButtonElement> = event => {
        if (event.button !== 0 || !event.isPrimary) return;

        event.preventDefault();
    };

    return (
        <Autocomplete.InputGroup ref={controlsRef} className="header-search__controls">
            <form ref={formRef} className="header-search__form" method="get" onSubmit={onSubmit} role="search">
                <Autocomplete.Input
                    ref={inputRef}
                    aria-label="Search"
                    autoComplete="off"
                    className="header-search__input"
                    data-cs-encrypt
                    onFocus={onInputFocus}
                    onKeyDown={onInputKeyDown}
                    placeholder="Search"
                />

                <Autocomplete.Clear aria-label="Clear search" className="header-search__clear" tabIndex={0}>
                    <Icon name="x" size="md" aria-hidden="true" />
                </Autocomplete.Clear>

                <button aria-label="Search" className="header-search__submit" type={query.trim() ? 'submit' : 'button'}>
                    <Icon name="search" size="md" aria-hidden="true" />
                </button>
            </form>

            {onCancel && (
                <button
                    className="header-search__cancel"
                    type="button"
                    onClick={onCancel}
                    onPointerDown={handleCancelPointerDown}
                >
                    Cancel
                </button>
            )}
        </Autocomplete.InputGroup>
    );
}
